import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    background: #e4eaf1;
`;

export const TestimonialsWrapper = styled.div`
    padding: 60px 140px;
    max-width: 1440px;
    margin: auto;

    @media screen and (max-width: 1200px) {
        padding: 60px;
    }

    @media screen and (max-width: 780px) {
        padding: 40px 20px;
    }
`;

export const Title = styled.div`
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
    color: #434f5a;
    @media screen and (max-width: 780px) {
        letter-spacing: 0.02em;
        font-size: 26px;
        line-height: 31px;
    }
`;

export const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 120px;
    @media screen and (max-width: 780px) {
        margin-top: 0;
        flex-direction: column;
    }
`;

export const CardWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;
    margin: 0 25px;
    @media screen and (max-width: 780px) {
        margin: 0;
        margin-top: 90px;
    }
`;

export const CardContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;
    margin: 0 25px;
    padding-bottom: 20px;
    margin: 0;
`;

export const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: -90px;
    @media screen and (max-width: 780px) {
        margin-top: -70px;
    }
`;

export const Image = styled.img`
    width: 131px;
    @media screen and (max-width: 780px) {
        width: 100px;
    }
`;

export const Name = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #0b0e34;
    @media screen and (max-width: 780px) {
        font-size: 18px;
        line-height: 28px;
    }
`;

export const Position = styled.div`
    display: flex;
    justify-content: center;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    align-items: center;
    letter-spacing: 0.5px;
    color: #5d607c;
    margin-top: 4px;
    @media screen and (max-width: 780px) {
        font-size: 12px;
        line-height: 15px;
    }
`;

export const Rating = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;

export const Review = styled.div`
    display: flex;
    justify-content: center;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    align-items: center;
    text-align: center;
    color: #8788a0;
    margin-top: 24px;
`;
